<template>
    <div>
      <v-row class="pl-3">
        <h2>
          <span class="blue-grey--text text--darken-1">Official Name: </span>
          {{ registration.officialName }}
        </h2>
      </v-row>
      <v-row>
        <v-col cols="12" sm="6">
          <h3>
            <span class="blue-grey--text text--darken-1">Call Name: </span>
            {{ registration.callName }}
          </h3>
          <h3>
            <span class="blue-grey--text text--darken-1">Gender: </span
            >{{ registration.gender }}
          </h3>
          <h3>
            <span class="blue-grey--text text--darken-1">Breed: </span
            >{{ registration.breed }}
          </h3>
          <h3>
            <span class="blue-grey--text text--darken-1">Birth Date: </span
            >{{ $dateUtils.formatDate(registration.birthDate) }}
          </h3>
          <h3>
            <span class="blue-grey--text text--darken-1">Previous Points Earned: </span
            >{{ registration.previousPointsEarned }}
          </h3>
        </v-col>
      </v-row>
    </div>
  </template>
  
  <script lang="ts">
  import Vue from "vue";
  export default Vue.extend({
    name: "QTDogRegistrationRequest",
    props: {
      registration: { type: Object },
    },
  });
  </script>